import React from "react";
import "./analyticsgrid.css";

export default function AnalyticsGrid({ children }) {
  return (
    <div
      style={{
        display: "grid",
        gap: "16px",
        width: "100%",
        // responsive breakpoints
      }}
      className="analytics-grid"
    >
      {children}

      <style>
        {`
          @media (min-width: 768px) {
            .analytics-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (min-width: 1200px) {
            .analytics-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }
        `}
      </style>
    </div>
  );
}